import debounce from 'lodash.debounce';
import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import Button from '@alltrails/denali/components/Button';
import type { TrailSearchResult } from '@alltrails/types/AlgoliaResults';
import styles from './styles.module.scss';
import TrailSegmentCard from './TrailSegmentCard';
import TrailSegmentsMap from './TrailSegmentsMap';

const defaultNumTrailsVisible = 10;

type TrailSegmentsProps = {
  hideMap?: boolean;
  numTrailsVisible?: number;
  trails: TrailSearchResult[];
};

// https://www.figma.com/design/B7oyzdXDXbRUGayrIwJnRp/Adv-Planning-2026--Handoff-?node-id=2136-51351&t=QdvY1ccj4HKq2Qkj-4
const TrailSegments = ({ hideMap, numTrailsVisible = defaultNumTrailsVisible, trails }: TrailSegmentsProps) => {
  const intl = useIntl();
  const [isShowingMore, setIsShowingMore] = useState(false);
  const [activeId, setActiveId] = useState<number>();

  const debouncedSetActiveId = useMemo(() => debounce((id?: number) => setActiveId(id), 100), []);

  const hasTooManyTrails = trails.length > numTrailsVisible;

  return (
    <div className={styles.content}>
      <div className={styles.trailList}>
        {(hasTooManyTrails && !isShowingMore ? trails.slice(0, numTrailsVisible) : trails).map((trail, index) => (
          <TrailSegmentCard
            key={trail.ID}
            onMouseEnter={() => debouncedSetActiveId(trail.ID)}
            onMouseLeave={() => debouncedSetActiveId(undefined)}
            ranking={index + 1}
            trail={trail}
          />
        ))}
        {!isShowingMore && hasTooManyTrails && (
          <Button onClick={() => setIsShowingMore(true)} text={intl.formatMessage({ defaultMessage: 'Show more' })} variant="primary" width="auto" />
        )}
      </div>
      {hideMap ? null : <TrailSegmentsMap activeId={activeId} trails={trails} />}
    </div>
  );
};

export default TrailSegments;
